<template>
  <div class="mainfooter _mainfooter">
    <div class="footerbody _footerbody">
      <div class="item item_no">
        <img src="@/assets/images/home/logo1.png" />
      </div>
      <div class="item">
        <div class="tit">
          {{ $store.state.chinese ? "社交媒体" : "Social media" }}
        </div>
        <div class="line"></div>
        <p>
          {{
            $store.state.chinese ? "微信公众号" : "WeChat official account"
          }}：{{
            $store.state.chinese
              ? websiteObj.wx_number
              : websiteObj.en_wx_number
          }}
        </p>
        <p>
          {{ $store.state.chinese ? "微信视频号" : "WeChat video Number" }}：{{
            $store.state.chinese
              ? websiteObj.wx_video_number
              : websiteObj.en_wx_video_number
          }}
        </p>
        <p>
          {{
            $store.state.chinese ? "微信管家号" : "WeChat housekeeper Number"
          }}：{{
            $store.state.chinese
              ? websiteObj.wx_manager_number
              : websiteObj.en_wx_manager_number
          }}
        </p>
        <p>
          {{ $store.state.chinese ? "微博" : "micro-blog" }} ：{{
            $store.state.chinese ? websiteObj.weibo : websiteObj.en_weibo
          }}
        </p>
        <p>
          {{ $store.state.chinese ? "B站" : "BILIBILI" }}：{{
            $store.state.chinese ? websiteObj.bilibili : websiteObj.en_bilibili
          }}
        </p>
      </div>
      <div class="item">
        <div class="tit">
          {{ $store.state.chinese ? "合作联系" : "PARTNERSHIP" }}
        </div>
        <div class="line"></div>
        <p>
          {{ $store.state.chinese ? "邮箱" : "Email" }}：{{ websiteObj.email }}
        </p>
        <p>
          {{ $store.state.chinese ? "电话" : "Phone" }}：{{ websiteObj.tel }}
        </p>
        <p>
          {{ $store.state.chinese ? "地址" : "Adress" }}：{{
            $store.state.chinese ? websiteObj.adress : websiteObj.en_adress
          }}
        </p>
      </div>
      <div class="item">
        <div class="tit">
          {{ $store.state.chinese ? "加入我们" : "Join Us" }}
        </div>
        <div class="line"></div>
        <p>
          <a @click="toUrl(join.link)">{{
            $store.state.chinese ? "了解最新岗位" : "Learn more about new work"
          }}</a>
        </p>
        <div class="line line1"></div>
      </div>
    </div>
    <div class="lines"></div>

    <div class="footer">
      <span>深圳市方至体育发展有限公司版权所有</span>
      <span>|</span>
      <span><a style="color:#fff;" :href="`https://beian.miit.gov.cn/#/Integrated/recordQuery`" target="_blank">
      粤ICP备19044582号-1
    </a></span>
    </div>
  </div>
</template>

<script>
import { siteConfig } from "@/api/foot";
import { pages } from "@/api/story";
export default {
  name: "mainfooter",
  data() {
    return {
      //网站信息
      websiteObj: {},
      join: {},
    };
  },
  components: {},
  methods: {
    async siteConfig() {
      const res = await siteConfig();
      if (res.code === 200) {
        this.websiteObj = res.result;
        this.$store.state.webconfig = res.result;
      }
    },
    network(data) {
      return pages(data).then((res) => {
        if (res.code === 200 && res.message === "ok") {
          return res.result;
        } else {
          console.log("请求失败");
        }
      });
    },
    toUrl(link) {
      if (!link) return;
      window.open(link);
    },
  },
  created() {
    this.siteConfig();
    this.network({ type: 4 }).then((res) => {
      this.join = res[0];
    });
  },
};
</script>

<style lang="less" scoped>
@media only screen and (min-width: 768px) {
  .mainfooter {
    background-image: url("https://www.kendalchina.com/static/img/footer.d595dcd.png");
    width: 100%;
    min-width: 1200px;
    padding: 40px 0;
    .footerbody {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .item {
        flex: 1;
        text-align: left;
        line-height: 60px;
        a {
          list-style: none;
          color: #409fff;
          text-decoration: none;
          cursor: pointer;
        }
        img {
          width: 181px;
          height: 72px;
          margin-top: 60px;
        }
        .tit {
          font-size: 16px;
          font-family:'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #ffffff;
        }
        .line {
          display: none;
        }
        p {
          font-size: 12px;
          font-family:'PingFang SC' ,'Microsoft YaHei';
          font-weight: 300;
          color: #ccc;
          line-height: 30px;
        }
      }
    }
    .lines {
      width: 100%;
      margin-top: 20px;
      height: 1px;
      background: #f0f2f5;
      opacity: 0.3;
    }
    .footer {
      width: 70%;
      margin: 10px auto 0;
      text-align: center;
      span {
        display: inline-block;
        font-size: 12px;
        font-family:'PingFang SC', 'Microsoft YaHei';
        font-weight: 300;
        color: #f0f2f5;
        line-height: 50px;
      }
      span:nth-child(2) {
        padding: 0 40px;
      }
       span:nth-child(3) {
         color: white;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .mainfooter {
    background-image: url("~@/assets/images/home/mfooter.png");
    width: 100%;
    padding: 20px 0;
    .footerbody {
      width: 100%;
      margin: 0 auto;
      padding: 0 20px;
      .item_no {
        display: none;
      }
      .item {
        text-align: left;
        line-height: 60px;
        margin-bottom: 20px;
        a {
          list-style: none;
          color: #409fff;
          text-decoration: none;
        }
        .tit {
          font-size: .6rem;
          font-family: 'PingFang SC';
          font-weight: bold;
          color: #f0f2f5;
        }
        .line {
          width: 100%;
          height: 1px;
          background: #ffffff;
          opacity: 0.3;
        }
        .line1 {
          margin-top: 40px;
        }
        p {
          font-size: .5rem;
          font-family:'PingFang SC', 'Microsoft YaHei';
          font-weight: 300;
          color: #ccc;
          line-height: 40px;
          a {
            cursor: pointer;            
          }
        }
      }
    }
    .lines {
      width: 100%;
      display: none;
      height: 1px;
      background: #f0f2f5;
      opacity: 0.3;
    }
    .footer {
      width: 100%;
      margin: 0 auto;
      text-align: center;
      span {
        display: inline-block;
        font-size: .5rem;
        font-family:'PingFang SC','Microsoft YaHei';
        font-weight: 300;
        color: #f0f2f5;
        line-height: 50px;
      }
      span:nth-child(2) {
        padding: 0 20px;
      }
       span:nth-child(3) {
         color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comcomponents/Footer.vue